import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { securityVersionHistoryEntityActions } from 'containers/App/modules/entities/securityVersionHistories/securityVersionHistoryEntity.slice';
import { createResetGridDataAction, createResetGridReducer, createSetGridParamsAction, createSetGridParamsReducer, GRID_INITIAL_STATE, createUpdateGridReducer } from 'containers/Grid/grid.utils';


const SEC_VER_HISTORY_STATE_KEY = 'securityVersionHistories';
const SEC_VER_HISTORY_GRID_STATE_KEY = 'securityVersionHistoriesGrid';
const setGridParams = createSetGridParamsAction(SEC_VER_HISTORY_GRID_STATE_KEY);
const resetGridData = createResetGridDataAction(SEC_VER_HISTORY_GRID_STATE_KEY);

export const INITIAL_STATE = {
    [SEC_VER_HISTORY_GRID_STATE_KEY]: GRID_INITIAL_STATE
};

const securityVersionHistorySlice = createSlice({
    name:          SEC_VER_HISTORY_STATE_KEY,
    initialState:  INITIAL_STATE,
    reducers:      {},
    extraReducers: {
        //GRID
        [securityVersionHistoryEntityActions.fetchSecurityVersionHistoriesSuccess]: createUpdateGridReducer(SEC_VER_HISTORY_GRID_STATE_KEY),
        [setGridParams]:                           createSetGridParamsReducer(SEC_VER_HISTORY_GRID_STATE_KEY),
        [resetGridData]:                           createResetGridReducer(SEC_VER_HISTORY_GRID_STATE_KEY),
    }
});


const getSecurityVersionHistoryState = state => state[SEC_VER_HISTORY_STATE_KEY] || INITIAL_STATE;


const selectSecurityVersionHistoryGrid = createSelector(
    getSecurityVersionHistoryState,
    securityVersionHistoryState => {
        return securityVersionHistoryState[SEC_VER_HISTORY_GRID_STATE_KEY]
    }
);

export const securityVersionHistorySelectors = {
    selectSecurityVersionHistoryGrid,
};

const {
} = securityVersionHistorySlice.actions;

export const securityVersionHistoryActions = {
    setGridParams,
    resetGridData
};
export default securityVersionHistorySlice.reducer;